__turbopack_context__.v({
  "desktopOnly": "PopTip-module__Lr_mJq__desktopOnly",
  "mobileOnly": "PopTip-module__Lr_mJq__mobileOnly",
  "triggerButton": "PopTip-module__Lr_mJq__triggerButton",
});
